"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StarCircleSymbolIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFF",
      d: "M.605 6.57a1 1 0 111.999 0 1 1 0 01-2 0",
      transform: "translate(-2 -3) translate(2 3)",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#FFF",
      d: "M9.945 19.89C4.462 19.89 0 15.43 0 9.947a1 1 0 112 0c0 4.38 3.564 7.945 7.945 7.945s7.945-3.564 7.945-7.945S14.326 2 9.945 2a7.943 7.943 0 00-6.024 2.765A1 1 0 112.405 3.46 9.943 9.943 0 019.945 0c5.483 0 9.945 4.462 9.945 9.946s-4.462 9.945-9.945 9.945",
      transform: "translate(-2 -3) translate(2 3)",
      className: "svg-fill-secondary"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#4CB05D",
      d: "M7.397 9.222l.992.966a.75.75 0 01.216.664l-.234 1.365 1.226-.644a.747.747 0 01.697 0l1.226.644-.234-1.365a.75.75 0 01.216-.664l.99-.966-1.37-.2a.752.752 0 01-.565-.41l-.612-1.241-.611 1.242a.754.754 0 01-.566.41l-1.37.199zm5.118 5.116a.753.753 0 01-.348-.086l-2.222-1.168-2.222 1.168a.752.752 0 01-1.087-.791l.423-2.474-1.796-1.751a.75.75 0 01.415-1.28l2.484-.361 1.11-2.25c.255-.512 1.092-.512 1.346 0l1.11 2.25 2.485.36a.748.748 0 01.605.512.748.748 0 01-.19.769l-1.797 1.75.424 2.475a.751.751 0 01-.74.877z",
      transform: "translate(-2 -3) translate(2 3)",
      className: "svg-fill-primary"
    })]
  })]
});

StarCircleSymbolIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(StarCircleSymbolIcon);

exports.default = _default;